import * as THREE from 'three';
import * as BufferGeometryUtils from 'three/addons/utils/BufferGeometryUtils.js';

window.$ = jQuery;
// import ParticleWave from 'particle-wave'
//https://codepen.io/stufreen/pen/KOWKBw
//https://www.vantajs.com/
if(jQuery('.our-work-header').length) {
    !function (e) {
    // jQuery('#post-32 .et-l.et-l--post >div:first-of-type .et_pb_section').append('<div id="waves-app"></div><div></div>')

    jQuery('body').append(`
    <script type="x-shader/x-vertex" id="vertexshader">
attribute float scale;

			void main() {

				vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );

				gl_PointSize = scale * ( 300.0 / - mvPosition.z );

				gl_Position = projectionMatrix * mvPosition;

			}
</script>

<script type="x-shader/x-fragment" id="fragmentshader">
uniform vec3 color;

			void main() {

				if ( length( gl_PointCoord - vec2( 0.5, 0.5 ) ) > 0.475 ) discard;

				gl_FragColor = vec4( color, 1.0 );

			}</script>
    
    `)

    const SEPARATION = 5, AMOUNTX = 1000, AMOUNTY = 1000;

    let container;
    let camera, scene, renderer;

    let particles, count = 0;

    // let mouseX = -160, mouseY = -40;
        let mouseX = -257, mouseY = -239;
    let windowHalfX = window.innerWidth / 2;
    let windowHalfY = window.innerHeight / 2;

    init();
    animate();

    function init() {

        container = document.createElement( 'div' );
        container.id = 'waves-app'
        document.querySelector('.our-work-header').appendChild( container );


        camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 100, 1000 );
        camera.position.z = 100;
        // camera.position.y = -100;
        camera.position.x = -500;

        scene = new THREE.Scene();
        scene.fog = new THREE.Fog( 0x0047ff, 0.0009,0.05 );

        //

        const numParticles = AMOUNTX * AMOUNTY;

        const positions = new Float32Array( numParticles * 3 );
        const scales = new Float32Array( numParticles );

        let i = 0, j = 0;

        for ( let ix = 0; ix < AMOUNTX; ix ++ ) {

            for ( let iy = 0; iy < AMOUNTY; iy ++ ) {

                positions[ i ] = ix * SEPARATION - ( ( AMOUNTX * SEPARATION ) / 2 ); // x
                positions[ i + 1 ] = 0; // y
                positions[ i + 2 ] = iy * SEPARATION - ( ( AMOUNTY * SEPARATION ) / 2 ); // z

                scales[ j ] = 0.01;

                i += 3;
                j ++;

            }

        }

        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
        geometry.setAttribute( 'scale', new THREE.BufferAttribute( scales, 1 ) );

        // const material = new THREE.ShaderMaterial( {
        //
        //   uniforms: {
        //     color: { value: new THREE.Color( 0xffffff ) },
        //   },
        //   vertexShader: document.getElementById( 'vertexshader' ).textContent,
        //   fragmentShader: document.getElementById( 'fragmentshader' ).textContent
        //
        // } );

        const sprite = new THREE.TextureLoader().load(  `${fdc.templateUrl}/images/disc.svg` );

        const material =new THREE.PointsMaterial( { size: 2, sizeAttenuation: true, map: sprite, alphaTest: 0.5, transparent: true } );
        material.color.setHex( 0x0047ff );

        //

        particles = new THREE.Points( geometry, material );
        scene.add( particles );

        //

        renderer = new THREE.WebGLRenderer( { antialias: true } );
        renderer.setPixelRatio( window.devicePixelRatio );
        renderer.setSize( window.innerWidth, window.innerHeight );
        renderer.setClearColor( 0xffffff, 0);

        container.appendChild( renderer.domElement );


        container.style.touchAction = 'none';
        container.addEventListener( 'pointermove', onPointerMove );

        //

        window.addEventListener( 'resize', onWindowResize );

    }

    function onWindowResize() {

        windowHalfX = window.innerWidth / 2;
        windowHalfY = window.innerHeight / 2;

        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();

        renderer.setSize( window.innerWidth, window.innerHeight );

    }

    //

    function onPointerMove( event ) {

        if ( event.isPrimary === false ) return;

        mouseX = event.clientX - windowHalfX;
        mouseY = event.clientY - windowHalfY;
        // console.log({mouseX,mouseY})

    }

    //

    function animate() {

        requestAnimationFrame( animate );

        render();

    }

    function render() {

        camera.position.x += ( mouseX - camera.position.x ) * .05;
        camera.position.y += ( - mouseY - camera.position.y ) * .05;
        camera.lookAt( scene.position );

        const positions = particles.geometry.attributes.position.array;
        const scales = particles.geometry.attributes.scale.array;

        let i = 0, j = 0;

        for ( let ix = 0; ix < AMOUNTX; ix ++ ) {

            for ( let iy = 0; iy < AMOUNTY; iy ++ ) {

                positions[ i + 1 ] = ( Math.sin( ( ix + count ) * 0.3 ) * 10 ) +
                    ( Math.sin( ( iy + count ) * 0.5 ) * 10 );

                scales[ j ] = ( Math.sin( ( ix + count ) * 0.3 ) + 1 ) * 20 +
                    ( Math.sin( ( iy + count ) * 0.5 ) + 1 ) * 20;

                i += 3;
                j ++;

            }

        }

        particles.geometry.attributes.position.needsUpdate = true;
        particles.geometry.attributes.scale.needsUpdate = true;

        renderer.render( scene, camera );

        count += 0.1;

    }

}()
}










if(jQuery('.about-us-our-purpose').length) {
    !function (e) {

        jQuery('body').append(`
    <script type="x-shader/x-vertex" id="vertexshader">
attribute float scale;

			void main() {

				vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );

				gl_PointSize = scale * ( 300.0 / - mvPosition.z );

				gl_Position = projectionMatrix * mvPosition;

			}
</script>

<script type="x-shader/x-fragment" id="fragmentshader">
uniform vec3 color;

			void main() {

				if ( length( gl_PointCoord - vec2( 0.5, 0.5 ) ) > 0.475 ) discard;

				gl_FragColor = vec4( color, 1.0 );

			}</script>
    
    `)

        const SEPARATION = 100, AMOUNTX = 50, AMOUNTY = 50;

        let container;
        let camera, scene, renderer;

        let particles, count = 0;

        let mouseX = -257, mouseY = -239;

        let windowHalfX = window.innerWidth / 2;
        let windowHalfY = window.innerHeight / 2;

        init();
        animate();

        function init() {

            container = document.createElement('div');
            container.id = 'waves-app'
            document.querySelector('.about-us-our-purpose').appendChild(container);


            camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 10000);
            camera.position.z = 1000;

            scene = new THREE.Scene();

            //

            const numParticles = AMOUNTX * AMOUNTY;

            const positions = new Float32Array(numParticles * 3);
            const scales = new Float32Array(numParticles);

            let i = 0, j = 0;

            for (let ix = 0; ix < AMOUNTX; ix++) {

                for (let iy = 0; iy < AMOUNTY; iy++) {

                    positions[i] = ix * SEPARATION - ((AMOUNTX * SEPARATION) / 2); // x
                    positions[i + 1] = 0; // y
                    positions[i + 2] = iy * SEPARATION - ((AMOUNTY * SEPARATION) / 2); // z

                    scales[j] = 1;

                    i += 3;
                    j++;

                }

            }

            const geometry = new THREE.BufferGeometry();
            geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
            geometry.setAttribute('scale', new THREE.BufferAttribute(scales, 1));

            const material = new THREE.ShaderMaterial({

                uniforms: {
                    color: {value: new THREE.Color(0x0047FF)},
                },
                vertexShader: document.getElementById('vertexshader').textContent,
                fragmentShader: document.getElementById('fragmentshader').textContent

            });

            //

            particles = new THREE.Points(geometry, material);
            scene.add(particles);

            //

            renderer = new THREE.WebGLRenderer({antialias: true});
            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setSize(window.innerWidth, window.innerHeight);
            renderer.setClearColor(0xffffff, 0);

            container.appendChild(renderer.domElement);


            container.style.touchAction = 'none';
            container.addEventListener('pointermove', onPointerMove);

            //

            window.addEventListener('resize', onWindowResize);

        }

        function onWindowResize() {

            windowHalfX = window.innerWidth / 2;
            windowHalfY = window.innerHeight / 2;

            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();

            renderer.setSize(window.innerWidth, window.innerHeight);

        }

        //

        function onPointerMove(event) {

            if (event.isPrimary === false) return;

            mouseX = event.clientX - windowHalfX;
            mouseY = event.clientY - windowHalfY;

            // console.log({mouseX,mouseY})
        }

        //

        function animate() {

            requestAnimationFrame(animate);

            render();

        }

        function render() {

            camera.position.x += (mouseX - camera.position.x) * .05;
            camera.position.y += (-mouseY - camera.position.y) * .05;
            camera.lookAt(scene.position);

            const positions = particles.geometry.attributes.position.array;
            const scales = particles.geometry.attributes.scale.array;

            let i = 0, j = 0;

            for (let ix = 0; ix < AMOUNTX; ix++) {

                for (let iy = 0; iy < AMOUNTY; iy++) {

                    positions[i + 1] = (Math.sin((ix + count) * 0.3) * 50) +
                        (Math.sin((iy + count) * 0.5) * 50);

                    scales[j] = (Math.sin((ix + count) * 0.3) + 1) * 20 +
                        (Math.sin((iy + count) * 0.5) + 1) * 20;

                    i += 3;
                    j++;

                }

            }

            particles.geometry.attributes.position.needsUpdate = true;
            particles.geometry.attributes.scale.needsUpdate = true;

            renderer.render(scene, camera);

            count += 0.1;

        }
    }()


    /*
    *Best waves
     const pointSize = 3
    const pw = new ParticleWave(document.getElementById('waves-app'), {
        uniforms: {
            size: { type: 'float', value: pointSize },
            field: { type: 'vec3', value: [0, 0, 0] },
            speed: { type: 'float', value: 7 }
        },
        texture:'data:image/svg+xml,%3Csvg width=\'144\' height=\'144\' viewBox=\'0 0 144 144\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M72.0816 0.18338C32.4362 0.18338 0.258301 32.3735 0.258301 72.034C0.258301 111.694 32.4362 143.885 72.0816 143.885C111.727 143.885 143.905 111.694 143.905 72.034C143.905 32.3735 111.727 0.18338 72.0816 0.18338Z\' fill=\'%230D2149\'/%3E%3C/svg%3E%0A',
        onResize (w, h, dpi) {
            const position = []
            const color = []
            const width = 400 * (w / h)
            const depth = 500
            const height = 10
            const distance = 5
            for (let x = 0; x < width; x += distance) {
                for (let z = 0; z < depth; z += distance) {
                    position.push(-width / 2 + x, -30, -depth / 2 + z)
                    color.push(0, 1 - (x / width) * 1, 0.5 + x / width * 0.5, z / depth)
                }
            }
            if (this.uniforms) {
                this.uniforms.field = [width, height, depth]
                this.uniforms.size = (h / 400) * pointSize * dpi
            }
            if (this.buffers) {
                this.buffers.position = position
                this.buffers.color = color
            }
        }
    })
*/


    /*
        !function (e) {


            var t = {};

            function r(n) {
                if (t[n]) return t[n].exports;
                var i = t[n] = {i: n, l: !1, exports: {}};
                return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports
            }

            r.m = e, r.c = t, r.d = function (e, t, n) {
                r.o(e, t) || Object.defineProperty(e, t, {enumerable: !0, get: n})
            }, r.r = function (e) {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
            }, r.t = function (e, t) {
                if (1 & t && (e = r(e)), 8 & t) return e;
                if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                var n = Object.create(null);
                if (r.r(n), Object.defineProperty(n, "default", {
                    enumerable: !0,
                    value: e
                }), 2 & t && "string" != typeof e) for (var i in e) r.d(n, i, function (t) {
                    return e[t]
                }.bind(null, i));
                return n
            }, r.n = function (e) {
                var t = e && e.__esModule ? function () {
                    return e.default
                } : function () {
                    return e
                };
                return r.d(t, "a", t), t
            }, r.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t)
            }, r.p = "", r(r.s = 0)
        }([function (e, t, r) {
            "use strict";

            function n(e) {
                return function (e) {
                    if (Array.isArray(e)) return i(e)
                }(e) || function (e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
                }(e) || function (e, t) {
                    if (e) {
                        if ("string" == typeof e) return i(e, t);
                        var r = Object.prototype.toString.call(e).slice(8, -1);
                        return "Map" === (r = "Object" === r && e.constructor ? e.constructor.name : r) || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(e, t) : void 0
                    }
                }(e) || function () {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                }()
            }

            function i(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
                return n
            }

            function a(e, t) {
                for (var r = 0; r < t.length; r++) {
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
                }
            }

            r.r(t);
            var o = new (function () {
                function e(t) {
                    var r = this, n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                    if (function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }(this, e), n = Object.assign({
                        antialias: !1,
                        depthTest: !1,
                        mousemove: !1,
                        autosize: !0,
                        side: "front",
                        vertex: "\n        #define M_PI 3.14159\n        precision highp float;\n        attribute vec4 a_position;\n        attribute vec4 a_color;\n        uniform vec2 u_resolution;\n        uniform vec2 u_mousemove;\n        precision highp float;\n        uniform float u_time;\n        uniform float u_size;\n        uniform float u_speed;\n        uniform vec3 u_field;\n        uniform mat4 u_projection;\n        varying vec4 v_color;\n        void main() {\n          vec3 pos = a_position.xyz;\n          pos.y += (\n            cos(pos.x / u_field.x * M_PI * 8.0 + u_time * u_speed) +\n            sin(pos.z / u_field.z * M_PI * 8.0 + u_time * u_speed)\n        ) * u_field.y;\n          gl_Position = u_projection * vec4(pos.xyz, a_position.w);\n          gl_PointSize = (u_size / gl_Position.w) * 100.0;\n          v_color = a_color;\n        }",
                        fragment: "\n        precision highp float;\n        uniform sampler2D u_texture;\n        uniform int u_hasTexture;\n        varying vec4 v_color;\n        void main() {\n          gl_FragColor = v_color * texture2D(u_texture, gl_PointCoord);\n        }",
                        uniforms: {},
                        buffers: {},
                        camera: {},
                        texture: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMAC/goGvDhmwcExrVjWzrm29TRqqSKenRXVklANSIUE8mRkGpv+HOfAAABCElEQVQ4y4VT13LDMAwLrUHteO+R9f/fWMfO6dLaPeKVEECRxOULWsEGpS9nULDwia2Y+ALqUNbAWeg775zv+sA4/FFRMxt8U2FZFCVWjR/YrH4/H9sarclSKdPMWKzb8VsEeHB3m0shkhVCyNzeXeAQ9Xl4opEieX2QCGnwGbj6GMyjw9t1K0fK9YZunPXeAGsfJtYjwzxaBnozGGorYz0ypK2HzQSYx1y8DgSRo2ewOiyh2QWOEk1Y9OrQV0a8TiBM1a8eMHWYnRMy7CZ4t1CmyRkhSUvP3gRXyHOCLBxNoC3IJv//ZrJ/kxxUHPUB+6jJZZHrpg6GOjnqaOmzp4NDR48OLxn/H27SRQ08S0ZJAAAAAElFTkSuQmCC",
                        onUpdate: function () {
                        },
                        onResize: function () {
                        }
                    }, n), !t) return !1;
                    var i = Object.assign({
                            time: {type: "float", value: 0},
                            hasTexture: {type: "int", value: 0},
                            resolution: {type: "vec2", value: [0, 0]},
                            mousemove: {type: "vec2", value: [0, 0]},
                            projection: {type: "mat4", value: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]}
                        }, n.uniforms),
                        a = Object.assign({position: {size: 3, data: []}, color: {size: 4, data: []}}, n.buffers),
                        o = Object.assign({fov: 60, near: 1, far: 1e3, aspect: 1, z: 110, perspective: !0}, n.camera),
                        u = document.createElement("canvas"), s = u.getContext("webgl", {antialias: n.antialias});
                    if (!s) return !1;
                    this.count = 0, this.gl = s, this.canvas = u, this.camera = o, this.holder = t, this.onUpdate = n.onUpdate, this.onResize = n.onResize, this.data = {}, t.appendChild(u), this.createProgram(n.vertex, n.fragment), this.createBuffers(a), this.createUniforms(i), this.updateBuffers(), this.updateUniforms(), this.createTexture(n.texture), s.enable(s.BLEND), s.enable(s.CULL_FACE), s.blendFunc(s.SRC_ALPHA, s.ONE), s[n.depthTest ? "enable" : "disable"](s.DEPTH_TEST), n.autosize && window.addEventListener("resize", (function (e) {
                        return r.resize(e)
                    }), !1), n.mousemove && window.addEventListener("mousemove", (function (e) {
                        return r.mousemove(e)
                    }), !1), this.resize(), this.update = this.update.bind(this), this.time = {
                        start: performance.now(),
                        old: performance.now()
                    }, this.update()
                }

                var t, r;
                return t = e, (r = [{
                    key: "mousemove", value: function (e) {
                        var t = e.pageX / this.width * 2 - 1;
                        e = e.pageY / this.height * 2 - 1;
                        this.uniforms.mousemove = [t, e]
                    }
                }, {
                    key: "resize", value: function (e) {
                        var t, r, n, i = this.holder, a = this.canvas, o = this.gl;
                        o && a && i && (t = this.width = i.offsetWidth, r = this.height = i.offsetHeight, n = this.aspect = t / r, i = this.dpi = devicePixelRatio, a.width = t * i, a.height = r * i, a.style.width = t + "px", a.style.height = r + "px", o.viewport(0, 0, t * i, r * i), o.clearColor(0, 0, 0, 0), this.uniforms.resolution = [t, r], this.uniforms.projection = this.setProjection(n), this.onResize(t, r, i))
                    }
                }, {
                    key: "setProjection", value: function (e) {
                        var t = this.camera;
                        if (t.perspective) {
                            t.aspect = e;
                            var r = t.fov * (Math.PI / 180);
                            e = Math.tan(.5 * Math.PI - .5 * r), r = 1 / (t.near - t.far);
                            return (r = [e / t.aspect, 0, 0, 0, 0, e, 0, 0, 0, 0, (t.near + t.far) * r, -1, 0, 0, t.near * t.far * r * 2, 0])[14] += t.z, r[15] += t.z, r
                        }
                        return [2 / this.width, 0, 0, 0, 0, -2 / this.height, 0, 0, 0, 0, 1, 0, -1, 1, 0, 1]
                    }
                }, {
                    key: "createShader", value: function (e, t) {
                        var r = this.gl;
                        e = r.createShader(e);
                        if (r.shaderSource(e, t), r.compileShader(e), r.getShaderParameter(e, r.COMPILE_STATUS)) return e;
                        console.log(r.getShaderInfoLog(e)), r.deleteShader(e)
                    }
                }, {
                    key: "createProgram", value: function (e, t) {
                        var r = this.gl, n = this.createShader(r.VERTEX_SHADER, e);
                        e = this.createShader(r.FRAGMENT_SHADER, t), t = r.createProgram();
                        r.attachShader(t, n), r.attachShader(t, e), r.linkProgram(t), r.getProgramParameter(t, r.LINK_STATUS) ? (r.useProgram(t), this.program = t) : (console.log(r.getProgramInfoLog(t)), r.deleteProgram(t))
                    }
                }, {
                    key: "createUniforms", value: function (e) {
                        var t = this, r = this.gl, n = this.data.uniforms = e, i = this.uniforms = {};
                        Object.keys(n).forEach((function (e) {
                            n[e].location = r.getUniformLocation(t.program, "u_" + e), Object.defineProperty(i, e, {
                                set: function (r) {
                                    n[e].value = r, t.setUniform(e, r)
                                }, get: function () {
                                    return n[e].value
                                }
                            })
                        }))
                    }
                }, {
                    key: "setUniform", value: function (e, t) {
                        var r = this.gl, i = this.data.uniforms[e];
                        switch (i.value = t, i.type) {
                            case"int":
                                r.uniform1i(i.location, t);
                                break;
                            case"float":
                                r.uniform1f(i.location, t);
                                break;
                            case"vec2":
                                r.uniform2f.apply(r, [i.location].concat(n(t)));
                                break;
                            case"vec3":
                                r.uniform3f.apply(r, [i.location].concat(n(t)));
                                break;
                            case"vec4":
                                r.uniform4f.apply(r, [i.location].concat(n(t)));
                                break;
                            case"mat2":
                                r.uniformMatrix2fv(i.location, !1, t);
                                break;
                            case"mat3":
                                r.uniformMatrix3fv(i.location, !1, t);
                                break;
                            case"mat4":
                                r.uniformMatrix4fv(i.location, !1, t)
                        }
                    }
                }, {
                    key: "updateUniforms", value: function () {
                        var e = this, t = this.data.uniforms;
                        Object.keys(t).forEach((function (r) {
                            var n = t[r];
                            e.uniforms[r] = n.value
                        }))
                    }
                }, {
                    key: "createBuffers", value: function (e) {
                        var t = this, r = this.data.buffers = e, n = this.buffers = {};
                        Object.keys(r).forEach((function (e) {
                            var i = r[e];
                            i.buffer = t.createBuffer("a_" + e, i.size), Object.defineProperty(n, e, {
                                set: function (n) {
                                    r[e].data = n, t.setBuffer(e, n), "position" === e && (t.count = r.position.data.length / 3)
                                }, get: function () {
                                    return r[e].data
                                }
                            })
                        }))
                    }
                }, {
                    key: "createBuffer", value: function (e, t) {
                        var r = this.gl, n = this.program;
                        n = r.getAttribLocation(n, e), e = r.createBuffer();
                        return r.bindBuffer(r.ARRAY_BUFFER, e), r.enableVertexAttribArray(n), r.vertexAttribPointer(n, t, r.FLOAT, !1, 0, 0), e
                    }
                }, {
                    key: "setBuffer", value: function (e, t) {
                        var r = this.gl, n = this.data.buffers;
                        null == e && !r.bindBuffer(r.ARRAY_BUFFER, null) || (r.bindBuffer(r.ARRAY_BUFFER, n[e].buffer), r.bufferData(r.ARRAY_BUFFER, new Float32Array(t), r.STATIC_DRAW))
                    }
                }, {
                    key: "updateBuffers", value: function () {
                        var e = this.buffers;
                        Object.keys(e).forEach((function (t) {
                            e[t] = t.data
                        })), this.setBuffer(null)
                    }
                }, {
                    key: "createTexture", value: function (e) {
                        var t = this.gl, r = t.createTexture();
                        t.bindTexture(t.TEXTURE_2D, r), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0])), this.texture = r, e && (this.uniforms.hasTexture = 1, this.loadTexture(e))
                    }
                }, {
                    key: "loadTexture", value: function (e) {
                        var t = this.gl, r = this.texture, n = new Image;
                        n.onload = function () {
                            t.bindTexture(t.TEXTURE_2D, r), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE)
                        }, n.src = e
                    }
                }, {
                    key: "update", value: function () {
                        var e, t, r, n = this.gl;
                        n && (t = ((e = performance.now()) - this.time.start) / 5e3, r = e - this.time.old, this.time.old = e, this.uniforms.time = t, 0 < this.count && (n.clear(n.COLOR_BUFFER_BIT), n.drawArrays(n.POINTS, 0, this.count)), this.onUpdate(r), requestAnimationFrame(this.update))
                    }
                }, {
                    key: "clear", value: function () {
                        var e = this.gl, t = this.holder;
                        e && t && (e.clear(e.COLOR_BUFFER_BIT | e.DEPTH_BUFFER_BIT | e.STENCIL_BUFFER_BIT), e.getAttachedShaders(this.program).forEach((function (t) {
                            e.deleteShader(t)
                        })), e.deleteProgram(this.program), Object.values(this.data.buffers).forEach((function (t) {
                            t = t.buffer, e.deleteBuffer(t)
                        })), e.deleteTexture(this.texture), this.program = null, this.data = null, this.buffers = null, this.texture = null, this.camera = null, this.holder = null, this.canvas = null, this.gl = null)
                    }
                }]) && a(t.prototype, r), e
            }())(document.getElementById("waves-app"), {
                uniforms: {
                    size: {type: "float", value: 4},
                    field: {type: "vec3", value: [0, 0, 0]},
                    speed: {type: "float", value: 7}
                }, onResize: function (e, t, r) {
                    for (var n = [], i = [], a = e / t * 400, o = 0; o < a; o += 9) for (var u = 0; u < 500; u += 9) n.push(-a / 2 + o, -30, -250 + u), i.push(0, 1 - o / a * 1, .5 + o / a * .5, u / 500);
                    this.uniforms.field = [a, 7, 500], this.buffers.position = n, this.buffers.color = i, this.uniforms.size = t / 400 * 4 * r
                }
            });
            // document.getElementById("clear").onclick = function () {
            //     console.log("ParticleWave will clear", o), o.clear()
            // }
        }]);
        *
     */
}










if(jQuery('.about-us-our-vision').length) {
    !function (e) {

        jQuery('body').append(`
		<script type="x-shader/x-vertex" id="vertexshader">

			attribute float size;
			attribute vec3 customColor;

			varying vec3 vColor;

			void main() {

				vColor = customColor;

				vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );

				gl_PointSize = size * ( 300.0 / -mvPosition.z );

				gl_Position = projectionMatrix * mvPosition;

			}

		</script>

		<script type="x-shader/x-fragment" id="fragmentshader">

			uniform vec3 color;
			uniform sampler2D pointTexture;
			uniform float alphaTest;

			varying vec3 vColor;

			void main() {

				gl_FragColor = vec4( color * vColor, 1.0 );

				gl_FragColor = gl_FragColor * texture2D( pointTexture, gl_PointCoord );

				if ( gl_FragColor.a < alphaTest ) discard;

			}

		</script>
    
    `)

        let renderer, scene, camera, stats;

        let particles;

        const PARTICLE_SIZE = 20;

        let raycaster, intersects;
        let pointer, INTERSECTED;

        init();
        animate();

        function init() {

            let container = document.createElement('div');
            container.id = 'waves-app2'
            document.querySelector('.about-us-our-vision').appendChild(container);

            scene = new THREE.Scene();

            camera = new THREE.PerspectiveCamera( 45, window.innerWidth / window.innerHeight, 1, 10000 );
            camera.position.z = 250;

            //

            let boxGeometry = new THREE.BoxGeometry( 200, 200, 200, 16, 16, 16 );

            // if normal and uv attributes are not removed, mergeVertices() can't consolidate indentical vertices with different normal/uv data

            boxGeometry.deleteAttribute( 'normal' );
            boxGeometry.deleteAttribute( 'uv' );

            boxGeometry = BufferGeometryUtils.mergeVertices( boxGeometry );

            //

            const positionAttribute = boxGeometry.getAttribute( 'position' );

            const colors = [];
            const sizes = [];

            const color = new THREE.Color();

            for ( let i = 0, l = positionAttribute.count; i < l; i ++ ) {

                color.setHSL( 0.01 + 0.1 * ( i / l ), 1.0, 0.5 );
                color.toArray( colors, i * 3 );

                sizes[ i ] = PARTICLE_SIZE * 0.5;

            }

            const geometry = new THREE.BufferGeometry();
            geometry.setAttribute( 'position', positionAttribute );
            geometry.setAttribute( 'customColor', new THREE.Float32BufferAttribute( colors, 3 ) );
            geometry.setAttribute( 'size', new THREE.Float32BufferAttribute( sizes, 1 ) );

            //

            // const material = new THREE.ShaderMaterial( {
            //
            //     uniforms: {
            //         color: { value: new THREE.Color( 0x000000 ) },
            //         pointTexture: { value: new THREE.TextureLoader().load( `${fdc.templateUrl}/images/disc.svg` ) },
            //         alphaTest: { value: 0.9 }
            //     },
            //     vertexShader: document.getElementById( 'vertexshader' ).textContent,
            //     fragmentShader: document.getElementById( 'fragmentshader' ).textContent
            //
            // } );
            const sprite = new THREE.TextureLoader().load(  `${fdc.templateUrl}/images/disc-lilac.svg` );

            const material =new THREE.PointsMaterial( { size: 3, sizeAttenuation: true, map: sprite, alphaTest: 1, transparent: true } );
             material.color.setHex( 0xC2B2E6 );


            //

            particles = new THREE.Points( geometry, material );
            scene.add( particles );



            //

            renderer = new THREE.WebGLRenderer();
            renderer.setPixelRatio( window.devicePixelRatio );
            renderer.setSize( window.innerWidth, window.innerHeight );
            renderer.setClearColor( 0xffffff, 0);
            container.appendChild( renderer.domElement );

            //

            raycaster = new THREE.Raycaster();
            pointer = new THREE.Vector2();

            //


            //

            window.addEventListener( 'resize', onWindowResize );
            document.addEventListener( 'pointermove', onPointerMove );

        }

        function onPointerMove( event ) {

            pointer.x = ( event.clientX / window.innerWidth ) * 2 - 1;
            pointer.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

        }

        function onWindowResize() {

            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();

            renderer.setSize( window.innerWidth, window.innerHeight );

        }

        function animate() {

            requestAnimationFrame( animate );

            render();

        }

        function render() {

            particles.rotation.x += 0.0005;
            particles.rotation.y += 0.001;

            const geometry = particles.geometry;
            const attributes = geometry.attributes;

            raycaster.setFromCamera( pointer, camera );

            intersects = raycaster.intersectObject( particles );

            if ( intersects.length > 0 ) {

                if ( INTERSECTED != intersects[ 0 ].index ) {

                    attributes.size.array[ INTERSECTED ] = PARTICLE_SIZE;

                    INTERSECTED = intersects[ 0 ].index;

                    attributes.size.array[ INTERSECTED ] = PARTICLE_SIZE * 1.25;
                    attributes.size.needsUpdate = true;

                }

            } else if ( INTERSECTED !== null ) {

                attributes.size.array[ INTERSECTED ] = PARTICLE_SIZE;
                attributes.size.needsUpdate = true;
                INTERSECTED = null;

            }

            renderer.render( scene, camera );

        }
    }()

}









if(jQuery('.about-us-our-mission').length) {
    !function (e) {

        const SCREEN_WIDTH = window.innerWidth,
            SCREEN_HEIGHT = window.innerHeight,

            r = 450;

        let mouseY = 0,

            windowHalfY = window.innerHeight / 2,

            camera, scene, renderer;

        init();
        animate();

        function init() {



            camera = new THREE.PerspectiveCamera( 80, SCREEN_WIDTH / SCREEN_HEIGHT, 1, 3000 );
            camera.position.z = 1000;

            scene = new THREE.Scene();

            const parameters = [[ 0.25, 0x0047FF, 1 ], [ 0.5, 0x0047FF, 1 ], [ 0.75, 0x0047FF, 0.75 ], [ 1, 0x0047FF, 0.5 ], [ 1.25, 0x0047FF, 0.8 ],
                [ 3.0, 0x0047FF, 0.75 ], [ 3.5, 0x0047FF, 0.5 ], [ 4.5, 0x0047FF, 0.25 ], [ 5.5, 0x0047FF, 0.125 ]
                ];

            const geometry = createGeometry();

            for ( let i = 0; i < parameters.length; ++ i ) {

                const p = parameters[ i ];

                const material = new THREE.LineBasicMaterial( { color: p[ 1 ], opacity: p[ 2 ] } );

                // material.linewidth = 10


                const line = new THREE.LineSegments( geometry, material );
                line.scale.x = line.scale.y = line.scale.z = p[ 0 ];
                line.userData.originalScale = p[ 0 ];
                line.rotation.y = Math.random() * Math.PI;
                line.updateMatrix();
                scene.add( line );

            }

            renderer = new THREE.WebGLRenderer( { antialias: true } );
            renderer.setPixelRatio( window.devicePixelRatio );
            renderer.setSize( SCREEN_WIDTH, SCREEN_HEIGHT );
            renderer.setClearColor( 0xffffff, 0);

            renderer.domElement.id = 'waves-app3'
            document.querySelector('.about-us-our-mission').appendChild( renderer.domElement );

            document.body.style.touchAction = 'none';
            document.body.addEventListener( 'pointermove', onPointerMove );

            //

            window.addEventListener( 'resize', onWindowResize );

            // test geometry swapability

            // setInterval( function () {
            //
            //     const geometry = createGeometry();
            //
            //     scene.traverse( function ( object ) {
            //
            //         if ( object.isLine ) {
            //
            //             object.geometry.dispose();
            //             object.geometry = geometry;
            //
            //         }
            //
            //     } );
            //
            // }, 5000 );

        }

        function createGeometry() {

            const geometry = new THREE.BufferGeometry();
            const vertices = [];

            const vertex = new THREE.Vector3();

            for ( let i = 0; i < 1500; i ++ ) {

                vertex.x = Math.random() * 2 - 1;
                vertex.y = Math.random() * 2 - 1;
                vertex.z = Math.random() * 2 - 1;
                vertex.normalize();
                vertex.multiplyScalar( r );

                vertices.push( vertex.x, vertex.y, vertex.z );

                vertex.multiplyScalar( Math.random() * 0.09 + 1 );

                vertices.push( vertex.x, vertex.y, vertex.z );

            }

            geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );

            return geometry;

        }

        function onWindowResize() {

            windowHalfY = window.innerHeight / 2;

            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();

            renderer.setSize( window.innerWidth, window.innerHeight );

        }

        function onPointerMove( event ) {

            if ( event.isPrimary === false ) return;

            mouseY = event.clientY - windowHalfY;

        }

        //

        function animate() {

            requestAnimationFrame( animate );

            render();

        }

        function render() {

            camera.position.y += ( - mouseY + 200 - camera.position.y ) * .05;
            camera.lookAt( scene.position );

            renderer.render( scene, camera );

            const time = Date.now() * 0.0001;

            for ( let i = 0; i < scene.children.length; i ++ ) {

                const object = scene.children[ i ];

                if ( object.isLine ) {

                    object.rotation.y = time * ( i < 4 ? ( i + 1 ) : - ( i + 1 ) );

                    if ( i < 5 ) {

                        const scale = object.userData.originalScale * ( i / 5 + 1 ) * ( 1 + 0.5 * Math.sin( 7 * time ) );

                        object.scale.x = object.scale.y = object.scale.z = scale;

                    }

                }

            }

        }
    }()

}




